
import { Switch } from "element-ui"
import { getNotification, setNotification } from "@/api/notification"
import { getLocalStorageAccountInfo } from "@/utils/utils"
import storage from "@/utils/storage"
export default {
  components: { [Switch.name]: Switch },
  props: {},
  data() {
    return {
      notification: {
        app: false,
        sms: false,
        email: false
      },
      notificationMap: {
        app: 5,
        sms: 2
      },
      accountInfo: null
    }
  },
  head() {
    return {
      title: `${this.$t("pageTitle.notification")}`
    }
  },
  computed: {},
  watch: {},
  created() {},
  async mounted() {
    this.accountInfo = storage.get("accountInfo", { useBase64: true }) || null
    const { data } = await getNotification()
    if (data) {
      const bancklistType = data.filter(i => i.yn === 1).map(item => item.blacklistType)
      Object.keys(this.notification).forEach(key => {
        this.notification[key] = !bancklistType.includes(this.notificationMap[key])
      })
    } else {
      Object.keys(this.notification).forEach(key => {
        this.notification[key] = true
      })
    }
  },
  methods: {
    async handelSwitchChange(val, type) {
      const { code } = await setNotification({
        param: {
          // 2-新增黑名单，1-移除黑名单
          edit: val ? 1 : 2,
          phoneNum: this.accountInfo?.areaCode + " " + this.accountInfo?.phone,
          blacklistType: type == "app" ? 5 : type == "sms" ? 2 : ""
        }
      })
      code == "0000"
        ? this.$message({
            message: this.$t("notification.operationSuccessful"),
            type: "success"
          })
        : this.$message({
            message: this.$t("notification.operationFailed"),
            type: "warning"
          })
    }
  }
}
